import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        languageState: true, // false=zh, true=en
    },
    mutations: {
        ChangeLanguageState(state, msg) {
          state.languageState = msg;
        },
    }
});


export default store;


// WEBPACK FOOTER //
// ./src/vuex/store.js